import React from "react";
import { Check, ExternalLink } from "lucide-react";
import { useCurrency } from "../contexts/CurrencyContext";

export const PackageCard = ({ pkg }) => {
  const { formatPrice } = useCurrency();

  const displayPrice = pkg.priceUSD ? formatPrice(pkg.priceUSD) : pkg.priceLabel;
  const displaySetupFee = pkg.setupFeeUSD
    ? `${formatPrice(pkg.setupFeeUSD)} Setup`
    : pkg.setupFeeLabel;

  return (
    <div
      className={`relative bg-white rounded-2xl p-6 card-hover ${
        pkg.popular ? "ring-2 ring-orange-primary shadow-orange" : "shadow-card"
      }`}
      data-testid={`package-card-${pkg.id}`}
    >
      {pkg.popular && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2">
          <span className="gradient-orange text-white text-xs font-semibold px-4 py-1 rounded-full">
            Most Popular
          </span>
        </div>
      )}
      <h3 className="font-display text-xl font-bold text-gray-dark mb-2">{pkg.name}</h3>
      <div className="flex items-baseline gap-1 mb-2">
        <span className="text-3xl font-bold text-orange-primary">{displayPrice}</span>
        {pkg.priceSuffix && <span className="text-gray-medium">{pkg.priceSuffix}</span>}
      </div>
      <p className="text-sm text-gray-medium mb-1">{displaySetupFee}</p>
      <p className="text-gray-medium text-sm mb-4">{pkg.description}</p>
      <ul className="space-y-2 mb-6">
        {pkg.features.map((feature, idx) => (
          <li key={idx} className="flex items-center gap-2 text-sm text-gray-dark">
            <Check size={16} className="text-green-500" />
            {feature}
          </li>
        ))}
      </ul>
      <a
        href={pkg.link}
        target="_blank"
        rel="noopener noreferrer"
        className={`block w-full text-center py-3 rounded-full font-semibold transition-all duration-300 ${
          pkg.popular ? "btn-primary" : "btn-secondary"
        }`}
        data-testid={`package-btn-${pkg.id}`}
      >
        View & Sign Up <ExternalLink size={14} className="inline ml-1" />
      </a>
    </div>
  );
};

export default PackageCard;
